import { render, staticRenderFns } from "./PTP.vue?vue&type=template&id=04cd7e8a&"
import script from "./PTP.vue?vue&type=script&lang=js&"
export * from "./PTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports